/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Load_FailedInputs */

const th_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดรายการแข่งขันไม่สำเร็จ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่`)
};

const en_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load events. Check your connection and retry.`)
};

const ja_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会を読み込めませんでした。接続を確認して再度お試しください。`)
};

const zh_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载赛事。请检查网络后重试。`)
};

const es_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se han podido cargar los eventos. Comprueba tu conexión e inténtalo de nuevo.`)
};

const pt_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os eventos. Verifique sua conexão e tente de novo.`)
};

const id_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara tidak bisa dimuat. Periksa koneksi Anda lalu coba lagi.`)
};

const fr_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les événements. Vérifiez votre connexion et réessayez.`)
};

const tl_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi na-load ang mga event. Suriin ang koneksyon mo at subukang muli.`)
};

const vi_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được sự kiện. Kiểm tra kết nối rồi thử lại.`)
};

const ko_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트를 불러오지 못했습니다. 연결을 확인하고 다시 시도하세요.`)
};

const de_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events konnten nicht geladen werden. Prüfe deine Verbindung und versuche es erneut.`)
};

const ru_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить события. Проверьте соединение и попробуйте снова.`)
};

const tr_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlikler yüklenemedi. Bağlantınızı kontrol edip yeniden deneyin.`)
};

const it_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare gli eventi. Controlla la connessione e riprova.`)
};

const pl_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wczytać wydarzeń. Sprawdź połączenie i spróbuj ponownie.`)
};

const uk_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося завантажити події. Перевірте з'єднання і спробуйте ще раз.`)
};

const hi_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन लोड नहीं हो सके। अपना कनेक्शन जाँचें और फिर कोशिश करें।`)
};

const ar_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تحميل الفعاليات. تحقق من اتصالك ثم أعد المحاولة.`)
};

const ms_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara tidak dapat dimuatkan. Semak sambungan anda dan cuba lagi.`)
};

const bn_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন লোড করা যায়নি। সংযোগ দেখে আবার চেষ্টা করুন।`)
};

const zh_tw2_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法載入賽事。請檢查網路後再試。`)
};

const zh_hk2_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法載入賽事。請檢查網絡後再試。`)
};

const ur_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ لوڈ نہیں ہو سکے۔ اپنا کنکشن دیکھ کر دوبارہ کوشش کریں۔`)
};

const fa_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رویدادها بارگذاری نشدند. اتصال‌تان را بررسی و دوباره تلاش کنید.`)
};

const sw_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio hayakuweza kupakiwa. Angalia muunganisho wako kisha ujaribu tena.`)
};

const nl_events_load_failed = /** @type {(inputs: Events_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenementen konden niet worden geladen. Controleer je verbinding en probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "Could not load events. Check your connection and retry." |
*
* @param {Events_Load_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const events_load_failed = /** @type {((inputs?: Events_Load_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Load_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_events_load_failed(inputs)
	if (locale === "ja") return ja_events_load_failed(inputs)
	if (locale === "zh") return zh_events_load_failed(inputs)
	if (locale === "es") return es_events_load_failed(inputs)
	if (locale === "pt") return pt_events_load_failed(inputs)
	if (locale === "id") return id_events_load_failed(inputs)
	if (locale === "fr") return fr_events_load_failed(inputs)
	if (locale === "tl") return tl_events_load_failed(inputs)
	if (locale === "vi") return vi_events_load_failed(inputs)
	if (locale === "ko") return ko_events_load_failed(inputs)
	if (locale === "de") return de_events_load_failed(inputs)
	if (locale === "ru") return ru_events_load_failed(inputs)
	if (locale === "tr") return tr_events_load_failed(inputs)
	if (locale === "it") return it_events_load_failed(inputs)
	if (locale === "pl") return pl_events_load_failed(inputs)
	if (locale === "uk") return uk_events_load_failed(inputs)
	if (locale === "hi") return hi_events_load_failed(inputs)
	if (locale === "ar") return ar_events_load_failed(inputs)
	if (locale === "ms") return ms_events_load_failed(inputs)
	if (locale === "bn") return bn_events_load_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_events_load_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_events_load_failed(inputs)
	if (locale === "ur") return ur_events_load_failed(inputs)
	if (locale === "fa") return fa_events_load_failed(inputs)
	if (locale === "sw") return sw_events_load_failed(inputs)
	if (locale === "nl") return nl_events_load_failed(inputs)
	return en_events_load_failed(inputs)
});